import * as React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
const LoginEmailIcon = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#E5E9FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00146 6.89238C5.00049 6.90731 5 6.92231 5 6.9375V13.0625C5 13.4422 5.3078 13.75 5.6875 13.75H14.3125C14.6922 13.75 15 13.4422 15 13.0625V6.9375C15 6.92231 14.9995 6.90731 14.9985 6.89238L10.1982 10.2808L10 10.4208L9.80175 10.2808L5.00146 6.89238ZM14.6164 6.32063C14.5248 6.27544 14.4215 6.25 14.3125 6.25H5.6875C5.57841 6.25 5.47526 6.27544 5.38361 6.32063L10 9.57925L14.6164 6.32063Z"
      fill="#0050FC"
    />
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
const LoginPhoneIcon = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#login-phone-icon-clip)">
      <circle cx="10" cy="10" r="10" fill="#F2F2F5" />
      <path
        d="M12.4495 4.5C13.0535 4.5 13.5432 4.98968 13.5432 5.59375V14.4062C13.5432 15.0103 13.0535 15.5 12.4495 15.5H7.55005C6.946 15.5 6.45634 15.0103 6.4563 14.4062V5.59375C6.45634 4.98971 6.946 4.50004 7.55005 4.5H12.4495ZM9.9436 13.1436C9.55836 13.1436 9.24634 13.467 9.24634 13.8662C9.24645 14.2653 9.55843 14.5889 9.9436 14.5889C10.3287 14.5888 10.6408 14.2653 10.6409 13.8662C10.6409 13.467 10.3288 13.1437 9.9436 13.1436ZM8.94263 5.83594C8.81719 5.83619 8.71518 5.94134 8.71509 6.07129C8.71509 6.20132 8.81714 6.30737 8.94263 6.30762H11.0657C11.1914 6.30762 11.2932 6.20147 11.2932 6.07129C11.2931 5.94119 11.1913 5.83594 11.0657 5.83594H8.94263Z"
        fill="#0050FC"
      />
    </g>
    <defs>
      <clipPath id="login-phone-icon-clip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export {LoginEmailIcon, LoginPhoneIcon}
